import React from 'react';
import PropTypes from 'prop-types';
import Header from './hero-components/header';
import Nav from './nav';

export default function Hero({ type }) {
  return (
    <>
      <Nav active={type} />
      <Header name={`${type} report`} />
    </>
  );
}

Hero.propTypes = {
  type: PropTypes.oneOf(['performance', 'audience']).isRequired,
};
